import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  // 首页
  {
    path: '/',
    name: 'home',
    component: () => import('../views/index.vue')
  },
    // 首页
  {
    path: '/face',
    name: 'face',
    component: () => import('../views/face.vue')
  },
  //脉诊
    {
    path: '/pulse',
    name: 'pulse',
    component: () => import('../views/pulse.vue')
  },
  {
    path: '/simple',
    name: 'simple',
    component: () => import('../views/simple.vue')
  },
  {
    path: '/faceSimple',
    name: 'faceSimple',
    component: () => import('../views/faceSimple.vue')
  },

]

const router = new VueRouter({
  mode: 'hash',
  base: '/',
  routes
})

export default router
